import { Buffer } from 'buffer';
import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';

globalThis.Buffer = globalThis.Buffer || Buffer;

const root = createRoot(document.getElementById('root'));
root.render(<App />);

// Remove existing service worker, NB! Can be removed afterwards
if (window.navigator && navigator.serviceWorker) {
    navigator.serviceWorker.getRegistrations().then(function unRegisterAll(registrations) {
        for (const registration of registrations) {
            registration.unregister();
        }
    });
}
